import { api } from "@/lib/api";

export type UploadedAsset = {
  assetId: string;
  companyId: string;
  contentType: string;
  byteSize: number;
  originalFilename: string | null;
};

export type UploadedFont = {
  assetId: string;
  companyId: string;
  contentType: string;
  byteSize: number;
  originalFilename: string | null;
  /** Nome de family sugerido pelo backend (arquivo sem extensão, limpo). */
  suggestedFamily: string;
};

export const assetsApi = {
  /**
   * Upload de uma imagem → cria um asset na company e retorna o assetId.
   * Usado pra imagem base das variações de título (quando o user sobe um
   * arquivo em vez de escolher da biblioteca de aprovados).
   */
  uploadImage: (companyId: string, file: File) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.postForm<UploadedAsset>(
      `/companies/${companyId}/assets/images`,
      fd,
    );
  },

  /**
   * Upload de um arquivo de fonte (.ttf/.otf/.woff) → cria um asset e retorna
   * o assetId + family sugerido. Usado na identidade visual (marca e produto)
   * pra a arte sair na tipografia REAL do cliente em vez do fallback Bricolage.
   */
  uploadFont: (companyId: string, file: File) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.postForm<UploadedFont>(
      `/companies/${companyId}/assets/fonts`,
      fd,
    );
  },
};
